import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EtagService {
    private etagRegistrar: Record<string, number> = {};

    public registerEtag(etag: string | null, registeredAt: string | null): void {
        if (!etag || !registeredAt) {
            return;
        }

        const registeredEtagDate = this.etagRegistrar[etag] as number | undefined;

        if (!registeredEtagDate) {
            this.etagRegistrar = {
                ...this.etagRegistrar,
                [etag]: Date.parse(registeredAt),
            };
        }
    }

    public getLatestEtag(): { id: string; date: Date } | undefined {
        const newestEtag = Object.entries(this.etagRegistrar)
            .sort(([, a], [, b]) => a - b)
            .pop();

        if (!newestEtag) {
            return undefined;
        }

        return {
            id: newestEtag[0],
            date: new Date(newestEtag[1]),
        };
    }
}
